(() => {
  const selector = '[data-valmonti-sticky-atc]';
  const mobileViewport = window.matchMedia('(max-width: 699px)');

  const init = (root) => {
    if (!root || root.dataset.valmontiStickyReady) return;

    const primaryButton = document.getElementById(root.dataset.primaryButton || '');
    if (!primaryButton) return;

    root.dataset.valmontiStickyReady = 'true';
    let primaryButtonAboveViewport = false;
    let footerVisible = false;

    const update = () => {
      const visible = mobileViewport.matches && primaryButtonAboveViewport && !footerVisible;
      root.classList.toggle('is-visible', visible);
      root.setAttribute('aria-hidden', String(!visible));
    };

    const primaryObserver = new IntersectionObserver(([entry]) => {
      primaryButtonAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      update();
    });
    primaryObserver.observe(primaryButton);

    const footer = document.querySelector('.valmonti-footer');
    const footerObserver = footer
      ? new IntersectionObserver(([entry]) => {
          footerVisible = entry.isIntersecting;
          update();
        })
      : null;
    if (footer && footerObserver) footerObserver.observe(footer);

    mobileViewport.addEventListener?.('change', update);
  };

  const observe = (scope = document) => scope.querySelectorAll(selector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
